module.exports = __webpack_public_path__ + "img/malay-DE.0d66ca5c.png";